export const mockReportGroups = {
  1: {
    reportTestCodes: [
      {
        code: "CP_Annual_BatteryLoadTest",
        opt1: {
          CP_Annual_BatteryLoadTest: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Annual_ConfigurationManagementValidation",
        opt1: {
          CP_Annual_ConfigurationManagementValidation: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Annual_FRA234_253_LA",
        opt1: {
          CP_Annual_FRA234_253_LA: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Annual_FRA234_255c",
        opt1: {
          CP_Annual_FRA234_255c: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Annual_FallProtectionSystemInspection",
        opt1: {
          CP_Annual_FallProtectionSystemInspection: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Annual_InspectionofCableandWireEntrancesTerminations",
        opt1: {
          CP_Annual_InspectionofCableandWireEntrancesTerminations: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Annual_InspectionofMastandCantileverStructures",
        opt1: {
          CP_Annual_InspectionofMastandCantileverStructures: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Annual_JointTestofPreemptionInterconnections",
        opt1: {
          CP_Annual_JointTestofPreemptionInterconnections: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Annual_OperatingSoftwareValidation",
        opt1: {
          CP_Annual_OperatingSoftwareValidation: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Annual_SwitchCircuitControllerCenteringDeviceTest",
        opt1: {
          CP_Annual_SwitchCircuitControllerCenteringDeviceTest: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Annual_TrackCircuitTest",
        opt1: {
          CP_Annual_TrackCircuitTest: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Annual_InsulatedJointsandTrackAppliancesTestandInspection",
        opt1: {
          CP_Annual_InsulatedJointsandTrackAppliancesTestandInspection: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Annual_GateArmsAndMechanism_FRA234_255",
        opt1: {
          CN_Annual_GateArmsAndMechanism_FRA234_255: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Annual_BatteryLoad",
        opt1: {
          CN_Annual_BatteryLoad: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Annual_PrimaryBatteryExhuastion",
        opt1: {
          CN_Annual_PrimaryBatteryExhuastion: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Annual_LightUnitAlignmentFRA234_253",
        opt1: {
          CN_Annual_LightUnitAlignmentFRA234_253: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Annual_ApproachesWithCWMS",
        opt1: {
          CN_Annual_ApproachesWithCWMS: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Annual_GeneracGeneratorInspection",
        opt1: {
          CN_Annual_GeneracGeneratorInspection: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Annual_GeneratorInspection",
        opt1: {
          CN_Annual_GeneratorInspection: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Annual_CableHousing",
        opt1: {
          CN_Annual_CableHousing: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Annual_ConditionOfPlans_FRA234_201And236_1",
        opt1: {
          CN_Annual_ConditionOfPlans_FRA234_201And236_1: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Annual_LampVoltageFRA234_253",
        opt1: {
          CN_Annual_LampVoltageFRA234_253: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Annual_WarningTime_FRA234_259",
        opt1: {
          CN_Annual_WarningTime_FRA234_259: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Annual_TimingDevices_FRA234_265",
        opt1: {
          CN_Annual_TimingDevices_FRA234_265: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_255c",
        opt1: {
          FRA234_255c: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_253_LV",
        opt1: {
          FRA234_253_LV: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_253_LA",
        opt1: {
          FRA234_253_LA: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Annual_FRA234_253A",
        opt1: {
          CP_Annual_FRA234_253A: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Annual_FRA234_259",
        opt1: {
          CP_Annual_FRA234_259: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Annual_FRA234_265",
        opt1: {
          CP_Annual_FRA234_265: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_255c",
        opt1: {
          FRA234_255c: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_253A",
        opt1: {
          FRA234_253A: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_265",
        opt1: {
          FRA234_265: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_259",
        opt1: {
          FRA234_259: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Annual_FlashRate_FRA234_253",
        opt1: {
          CN_Annual_FlashRate_FRA234_253: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "NYSW_Annual_LampVoltage",
        opt1: {
          NYSW_Annual_LampVoltage: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Monthly_ACSupplyVoltage",
        opt1: {
          CP_Monthly_ACSupplyVoltage: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Monthly_BatteryIsolationTest",
        opt1: {
          CP_Monthly_BatteryIsolationTest: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Monthly_EORInspectionandHeaterOperationalTest",
        opt1: {
          CP_Monthly_EORInspectionandHeaterOperationalTest: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Monthly_FRA234_251",
        opt1: {
          CP_Monthly_FRA234_251: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Monthly_FRA234_253M",
        opt1: {
          CP_Monthly_FRA234_253M: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Monthly_GateArmOperationalTest",
        opt1: {
          CP_Monthly_GateArmOperationalTest: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Monthly_GateMech.HeaterDefrosterOperationalTest",
        opt1: {
          "CP_Monthly_GateMech.HeaterDefrosterOperationalTest": {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Monthly_HXP1Threecardislandtest",
        opt1: {
          CP_Monthly_HXP1Threecardislandtest: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Monthly_LightUnitVisibiltyInspection",
        opt1: {
          CP_Monthly_LightUnitVisibiltyInspection: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Monthly_PrimaryBatteryTrackCircuit",
        opt1: {
          CP_Monthly_PrimaryBatteryTrackCircuit: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Monthly_ValidationofLogbook",
        opt1: {
          CP_Monthly_ValidationofLogbook: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Monthly_VisualInspectionofSurgeProtection",
        opt1: {
          CP_Monthly_VisualInspectionofSurgeProtection: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Monthly_VisualandOperationalInspection",
        opt1: {
          CP_Monthly_VisualandOperationalInspection: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Monthly_WarningBellAudibleTest",
        opt1: {
          CP_Monthly_WarningBellAudibleTest: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Monthly_PreemptionAndAAWS_FRA234_261",
        opt1: {
          CN_Monthly_PreemptionAndAAWS_FRA234_261: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Monthly_GeneratorAtsTest",
        opt1: {
          CN_Monthly_GeneratorAtsTest: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Monthly_ACAndDCMode",
        opt1: {
          CN_Monthly_ACAndDCMode: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Monthly_Bell_FRA234_257",
        opt1: {
          CN_Monthly_Bell_FRA234_257: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Monthly_ACVoltage",
        opt1: {
          CN_Monthly_ACVoltage: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Monthly_PrimaryApproachCircuits",
        opt1: {
          CN_Monthly_PrimaryApproachCircuits: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Monthly_CWMSDevices",
        opt1: {
          CN_Monthly_CWMSDevices: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Monthly_LightUnitsAndSigns_FRA234_253",
        opt1: {
          CN_Monthly_LightUnitsAndSigns_FRA234_253: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Monthly_GateArmsAndMechanism_FRA234_255ab",
        opt1: {
          CN_Monthly_GateArmsAndMechanism_FRA234_255ab: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Monthly_PrimaryBatteryAndGrounds_FRA236_107And234_249And234_251",
        opt1: {
          CN_Monthly_PrimaryBatteryAndGrounds_FRA236_107And234_249And234_251: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Monthly_SecondaryBatteryAndGrounds_FRA234_249And234_251",
        opt1: {
          CN_Monthly_SecondaryBatteryAndGrounds_FRA234_249And234_251: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Monthly_ControllingDevices_FRA234_257ab",
        opt1: {
          CN_Monthly_ControllingDevices_FRA234_257ab: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_253M",
        opt1: {
          FRA234_253M: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_251",
        opt1: {
          FRA234_251: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_257",
        opt1: {
          FRA234_257: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_255",
        opt1: {
          FRA234_255: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "NYSW_Monthly_InspectionOfSignage",
        opt1: {
          NYSW_Monthly_InspectionOfSignage: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Monthly_FRA234_249",
        opt1: {
          CP_Monthly_FRA234_249: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Monthly_FRA234_261",
        opt1: {
          CP_Monthly_FRA234_261: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Monthly_FRA234_259",
        opt1: {
          CP_Monthly_FRA234_259: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_249",
        opt1: {
          FRA234_249: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_251",
        opt1: {
          FRA234_251: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_253M",
        opt1: {
          FRA234_253M: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_255",
        opt1: {
          FRA234_255: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_261",
        opt1: {
          FRA234_261: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Quarterly_CutoutOverrideCircuitTest",
        opt1: {
          CP_Quarterly_CutoutOverrideCircuitTest: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Quarterly_ElectronicEquipmentDateandTimeVerification",
        opt1: {
          CP_Quarterly_ElectronicEquipmentDateandTimeVerification: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Quarterly_FRA234_271",
        opt1: {
          CP_Quarterly_FRA234_271: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Quarterly_ForeignACVoltageTest",
        opt1: {
          CP_Quarterly_ForeignACVoltageTest: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Quarterly_InspectionofInsulatedTrackAppliances",
        opt1: {
          CP_Quarterly_InspectionofInsulatedTrackAppliances: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Quarterly_sfrtaSwitchshuntFouling",
        opt1: {
          CP_Quarterly_sfrtaSwitchshuntFouling: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Quarterly_GeneratorInspection",
        opt1: {
          CN_Quarterly_GeneratorInspection: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Quarterly_CutoutCircuits_FRA234_269",
        opt1: {
          CN_Quarterly_CutoutCircuits_FRA234_269: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Quarterly_InsulatedJointsAndTrackConnections_FRA234_271",
        opt1: {
          CN_Quarterly_InsulatedJointsAndTrackConnections_FRA234_271: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Quarterly_PrimaryBatteryAndGrounds_FRA236_107And234_249And234_251",
        opt1: {
          CN_Quarterly_PrimaryBatteryAndGrounds_FRA236_107And234_249And234_251: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Quarterly_SecondaryBatteryAndGrounds_FRA234_249And234_251",
        opt1: {
          CN_Quarterly_SecondaryBatteryAndGrounds_FRA234_249And234_251: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FGA_Quarter_CircuitPlansReview",
        opt1: {
          FGA_Quarter_CircuitPlansReview: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_271",
        opt1: {
          FRA234_271: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Quarterly_FRA234_269",
        opt1: {
          CP_Quarterly_FRA234_269: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_269",
        opt1: {
          FRA234_269: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_SemiAnnual_FRA234_255c",
        opt1: {
          CP_SemiAnnual_FRA234_255c: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_SemiAnnual_RelayVisualInspection",
        opt1: {
          CP_SemiAnnual_RelayVisualInspection: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_SemiAnnual_GateArmandMechanismVisualInspection",
        opt1: {
          CP_SemiAnnual_GateArmandMechanismVisualInspection: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_SemiAnnual_InspectionofRailBondsandTrackConnectionsHalfYearly",
        opt1: {
          CP_SemiAnnual_InspectionofRailBondsandTrackConnectionsHalfYearly: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_Weekly_VisualandOperationalInspectionWeek",
        opt1: {
          CP_Weekly_VisualandOperationalInspectionWeek: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_FRA234_267And236_108",
        opt1: {
          CP_FRA234_267And236_108: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_267And236_108",
        opt1: {
          FRA234_267And236_108: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_FRA234_263And236_106",
        opt1: {
          CP_FRA234_263And236_106: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_263And236_106",
        opt1: {
          FRA234_263And236_106: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_10Y_FRA236_267And236_108",
        opt1: {
          CN_10Y_FRA236_267And236_108: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CP_fraBatteryCardForm",
        opt1: {
          CP_fraBatteryCardForm: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Monthly_PrimaryBatteryAndGrounds_FRA236_107And234_249And234_251",
        opt1: {
          CN_Monthly_PrimaryBatteryAndGrounds_FRA236_107And234_249And234_251: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Monthly_SecondaryBatteryAndGrounds_FRA234_249And234_251",
        opt1: {
          CN_Monthly_SecondaryBatteryAndGrounds_FRA234_249And234_251: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Quarterly_PrimaryBatteryAndGrounds_FRA236_107And234_249And234_251",
        opt1: {
          CN_Quarterly_PrimaryBatteryAndGrounds_FRA236_107And234_249And234_251: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Quarterly_SecondaryBatteryAndGrounds_FRA234_249And234_251",
        opt1: {
          CN_Quarterly_SecondaryBatteryAndGrounds_FRA234_249And234_251: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "FRA234_253A",
        opt1: {
          FRA234_253A: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_Annual_FlashRate_FRA234_253",
        opt1: {
          CN_Annual_FlashRate_FRA234_253: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_10Y_FRA236_267And236_108",
        opt1: {
          CN_10Y_FRA236_267And236_108: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "CN_2Year_GeneratorInspection",
        opt1: {
          CN_2Year_GeneratorInspection: {
            default: {
              CPGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "grade_1001b1",
        opt1: {
          grade_1001b1: {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_303",
        opt1: {
          grade_303: {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_201",
        opt1: {
          grade_201: {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_202",
        opt1: {
          grade_202: {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_203",
        opt1: {
          grade_203: {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(b)2",
        opt1: {
          "grade_1001(b)2": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(b)3",
        opt1: {
          "grade_1001(b)3": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(b)4",
        opt1: {
          "grade_1001(b)4": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(b)5",
        opt1: {
          "grade_1001(b)5": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(b)6",
        opt1: {
          "grade_1001(b)6": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(b)7",
        opt1: {
          "grade_1001(b)7": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(b)8",
        opt1: {
          "grade_1001(b)8": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_801",
        opt1: {
          grade_801: {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_703",
        opt1: {
          grade_703: {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(c)1",
        opt1: {
          "grade_1001(c)1": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_401(a)",
        opt1: {
          "grade_401(a)": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_701",
        opt1: {
          grade_701: {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(d)1",
        opt1: {
          "grade_1001(d)1": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(d)2",
        opt1: {
          "grade_1001(d)2": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(e)1",
        opt1: {
          "grade_1001(e)1": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(e)2",
        opt1: {
          "grade_1001(e)2": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(e)3",
        opt1: {
          "grade_1001(e)3": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_702",
        opt1: {
          grade_702: {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(e)4",
        opt1: {
          "grade_1001(e)4": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(e)5",
        opt1: {
          "grade_1001(e)5": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(e)6",
        opt1: {
          "grade_1001(e)6": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(e)7",
        opt1: {
          "grade_1001(e)7": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(e)8",
        opt1: {
          "grade_1001(e)8": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_402",
        opt1: {
          grade_402: {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_901",
        opt1: {
          grade_901: {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1101",
        opt1: {
          grade_1101: {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "grade_1001(e)9",
        opt1: {
          "grade_1001(e)9": {
            default: {
              GradeCrossingWarningReport: true,
            },
          },
        },
      },
      {
        code: "sfrtaSwitchcircuitControllerNormal",
        opt1: {
          sfrtaSwitchcircuitControllerNormal: {
            default: {
              sfrtaSwitchTests: true,
            },
          },
        },
      },
      {
        code: "sfrtaSwitchcircuitControllerReverse",
        opt1: {
          sfrtaSwitchcircuitControllerReverse: {
            default: {
              sfrtaSwitchTests: true,
            },
          },
        },
      },
      {
        code: "sfrtaSwitchshuntFouling",
        opt1: {
          sfrtaSwitchshuntFouling: {
            default: {
              sfrtaSwitchTests: true,
            },
          },
        },
      },
      {
        code: "sfrtaSwitchLockRodNormal",
        opt1: {
          sfrtaSwitchLockRodNormal: {
            default: {
              sfrtaSwitchTests: true,
            },
          },
        },
      },
      {
        code: "sfrtaSwitchLockRodReverse",
        opt1: {
          sfrtaSwitchLockRodReverse: {
            default: {
              sfrtaSwitchTests: true,
            },
          },
        },
      },
      {
        code: "CN_Quarterly_SwitchCircuitControllerNormal_FRA236_103",
        opt1: {
          CN_Quarterly_SwitchCircuitControllerNormal_FRA236_103: {
            default: {
              sfrtaSwitchTests: true,
            },
          },
        },
      },
      {
        code: "CN_Quarterly_SwitchCircuitControllerReverse_FRA236_103",
        opt1: {
          CN_Quarterly_SwitchCircuitControllerReverse_FRA236_103: {
            default: {
              sfrtaSwitchTests: true,
            },
          },
        },
      },
      {
        code: "CN_Quarterly_FoulingCircuits_FRA236_104",
        opt1: {
          CN_Quarterly_FoulingCircuits_FRA236_104: {
            default: {
              sfrtaSwitchTests: true,
            },
          },
        },
      },
      {
        code: "CN_Monthly_SwitchObstructionNormal_FRA236_382",
        opt1: {
          CN_Monthly_SwitchObstructionNormal_FRA236_382: {
            default: {
              sfrtaSwitchTests: true,
            },
          },
        },
      },
      {
        code: "CN_Monthly_SwitchObstructionReverse_FRA236_382",
        opt1: {
          CN_Monthly_SwitchObstructionReverse_FRA236_382: {
            default: {
              sfrtaSwitchTests: true,
            },
          },
        },
      },
      {
        code: "sfrtaMechanical236_376",
        opt1: {
          sfrtaMechanical236_376: {
            default: {
              sfrtaInterLockingTests: true,
            },
          },
        },
      },
      {
        code: "sfrtaApproach236_377",
        opt1: {
          sfrtaApproach236_377: {
            default: {
              sfrtaInterLockingTests: true,
            },
          },
        },
      },
      {
        code: "sfrtaTime236_378",
        opt1: {
          sfrtaTime236_378: {
            default: {
              sfrtaInterLockingTests: true,
            },
          },
        },
      },
      {
        code: "sfrtaRoute236_379",
        opt1: {
          sfrtaRoute236_379: {
            default: {
              sfrtaInterLockingTests: true,
            },
          },
        },
      },
      {
        code: "sfrtaIndication236_380",
        opt1: {
          sfrtaIndication236_380: {
            default: {
              sfrtaInterLockingTests: true,
            },
          },
        },
      },
      {
        code: "sfrtaTraffic236_381",
        opt1: {
          sfrtaTraffic236_381: {
            default: {
              sfrtaInterLockingTests: true,
            },
          },
        },
      },
      {
        code: "sfrtaHotBox30Days",
        opt1: {
          sfrtaHotBox30Days: {
            default: {
              sfrtaHotBoxDefectDetectorTests: true,
            },
          },
        },
      },
      {
        code: "sfrtaHotBox90Days",
        opt1: {
          sfrtaHotBox90Days: {
            default: {
              sfrtaHotBoxDefectDetectorTests: true,
            },
          },
        },
      },
      {
        code: "sfrtaDraggingEquip30Days",
        opt1: {
          sfrtaDraggingEquip30Days: {
            default: {
              sfrtaHotBoxDefectDetectorTests: true,
            },
          },
        },
      },
      {
        code: "atlasRotorBladeVisualInspection",
        opt1: {
          atlasRotorBladeVisualInspection: {
            default: {
              atlasInspectionConnection: true,
            },
          },
        },
      },
      {
        code: "atlasRotorBladeTorqueScrewConnections",
        opt1: {
          atlasRotorBladeTorqueScrewConnections: {
            default: {
              atlasInspectionConnection: true,
            },
          },
        },
      },
      {
        code: "atlasDrivetrainTorqueScrewConnections",
        opt1: {
          atlasDrivetrainTorqueScrewConnections: {
            default: {
              atlasInspectionConnection: true,
            },
          },
        },
      },
      {
        code: "atlasDrivetrainVisualInspection",
        opt1: {
          atlasDrivetrainVisualInspection: {
            default: {
              atlasInspectionConnection: true,
            },
          },
        },
      },
      {
        code: "atlasDrivetrainLubricationInspection",
        opt1: {
          atlasDrivetrainLubricationInspection: {
            default: {
              atlasInspectionConnection: true,
            },
          },
        },
      },
      {
        code: "atlasSupportStructureVisualInspection",
        opt1: {
          atlasSupportStructureVisualInspection: {
            default: {
              atlasInspectionConnection: true,
            },
          },
        },
      },
      {
        code: "atlasSupportStructureTorqueScrewConnections",
        opt1: {
          atlasSupportStructureTorqueScrewConnections: {
            default: {
              atlasInspectionConnection: true,
            },
          },
        },
      },
      {
        code: "onr_SemiAnnual_HydraulicMotorCurrentTest",
        opt1: {
          onr_SemiAnnual_HydraulicMotorCurrentTest: {
            default: {
              onrSwitchTests: true,
            },
          },
        },
      },
      {
        code: "onr_Quarterly_BatteryVoltageTest",
        opt1: {
          onr_Quarterly_BatteryVoltageTest: {
            default: {
              onrSwitchTests: true,
            },
          },
        },
      },
      {
        code: "onr_Monthly_SwitchVisualInspection",
        opt1: {
          onr_Monthly_SwitchVisualInspection: {
            default: {
              onrSwitchTests: true,
            },
          },
        },
      },
      {
        code: "onr_Monthly_SwitchObstructionNormal",
        opt1: {
          onr_Monthly_SwitchObstructionNormal: {
            default: {
              onrSwitchTests: true,
            },
          },
        },
      },
      {
        code: "onr_Monthly_SwitchObstructionReverse",
        opt1: {
          onr_Monthly_SwitchObstructionReverse: {
            default: {
              onrSwitchTests: true,
            },
          },
        },
      },
      {
        code: "onr_Monthly_PointPressureTest",
        opt1: {
          onr_Monthly_PointPressureTest: {
            default: {
              onrSwitchTests: true,
            },
          },
        },
      },
      {
        code: "onr_Monthly_SwitchMachineOperation",
        opt1: {
          onr_Monthly_SwitchMachineOperation: {
            default: {
              onrSwitchTests: true,
            },
          },
        },
      },
      {
        code: "onr_Annual_SwitchMachineOperation",
        opt1: {
          onr_Annual_SwitchMachineOperation: {
            default: {
              onrSwitchTests: true,
            },
          },
        },
      },
      {
        code: "onr_Annual_TransducerOccupancyDTMFOperation",
        opt1: {
          onr_Annual_TransducerOccupancyDTMFOperation: {
            default: {
              onrSwitchTests: true,
            },
          },
        },
      },
      {
        code: "LIRR_ACPowerGroundsFRA234_249",
        opt1: {
          LIRR_ACPowerGroundsFRA234_249: {
            default: {
              lirrHighwayGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "LIRR_StandbyPowerFRA234_251",
        opt1: {
          LIRR_StandbyPowerFRA234_251: {
            default: {
              lirrHighwayGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "LIRR_trackBatteries",
        opt1: {
          LIRR_trackBatteries: {
            default: {
              lirrHighwayGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "LIRR_FlasherLightsFRA234_217_253",
        opt1: {
          LIRR_FlasherLightsFRA234_217_253: {
            default: {
              lirrHighwayGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "LIRR_GateArmsMechanismAndLightsFRA234_219_223_255",
        opt1: {
          LIRR_GateArmsMechanismAndLightsFRA234_219_223_255: {
            default: {
              lirrHighwayGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "LIRR_GateOperationFRA234_223_255",
        opt1: {
          LIRR_GateOperationFRA234_223_255: {
            default: {
              lirrHighwayGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "LIRR_MiscWarningSystemOperationFRA235_257",
        opt1: {
          LIRR_MiscWarningSystemOperationFRA235_257: {
            default: {
              lirrHighwayGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "LIRR_TrafficPreEmptionFRA234_261",
        opt1: {
          LIRR_TrafficPreEmptionFRA234_261: {
            default: {
              lirrHighwayGradeCrossing: true,
            },
          },
        },
      },
      {
        code: "LIRR_30DaySwitchObstructionTest",
        opt1: {
          LIRR_30DaySwitchObstructionTest: {
            default: {
              lirrSwitchTestsAndInspection: true,
            },
          },
        },
      },
      {
        code: "LIRR_90DaySwitchCircuitControllers",
        opt1: {
          LIRR_90DaySwitchCircuitControllers: {
            default: {
              lirrSwitchTestsAndInspection: true,
            },
          },
        },
      },
      {
        code: "periodic92Days",
        opt1: {
          periodic92Days: {
            default: {
              periodic: true,
            },
          },
        },
      },
      {
        code: "periodic184Days",
        opt1: {
          periodic184Days: {
            default: {
              periodic: true,
            },
          },
        },
      },
      {
        code: "periodic368Days",
        opt1: {
          periodic368Days: {
            default: {
              periodic: true,
            },
          },
        },
      },
      {
        code: "handBreakTest105c",
        opt1: {
          handBreakTest105c: {
            default: {
              periodic: true,
            },
          },
        },
      },
      {
        code: "eventRecordTest25d",
        opt1: {
          eventRecordTest25d: {
            default: {
              periodic: true,
            },
          },
        },
      },
      {
        code: "eventRecordMicroprocessorTest27c",
        opt1: {
          eventRecordMicroprocessorTest27c: {
            default: {
              periodic: true,
            },
          },
        },
      },
      {
        code: "AirBrakeAFMLevelOne",
        opt1: {
          AirBrakeAFMLevelOne: {
            default: {
              airbrake: true,
            },
          },
        },
      },
      {
        code: "AirBrakeSys1Lvl2",
        opt1: {
          AirBrakeSys1Lvl2: {
            default: {
              airbrake: true,
            },
          },
        },
      },
      {
        code: "AirBrakeSys2Lvl2",
        opt1: {
          AirBrakeSys2Lvl2: {
            default: {
              airbrake: true,
            },
          },
        },
      },
      {
        code: "AirBrakeSys3Lvl2",
        opt1: {
          AirBrakeSys3Lvl2: {
            default: {
              airbrake: true,
            },
          },
        },
      },
      {
        code: "AirBrakeSys4Lvl2",
        opt1: {
          AirBrakeSys4Lvl2: {
            default: {
              airbrake: true,
            },
          },
        },
      },
      {
        code: "AirBrakeSys1Lvl3",
        opt1: {
          AirBrakeSys1Lvl3: {
            default: {
              airbrake: true,
            },
          },
        },
      },
      {
        code: "AirBrakeSys2Lvl3",
        opt1: {
          AirBrakeSys2Lvl3: {
            default: {
              airbrake: true,
            },
          },
        },
      },
      {
        code: "AirBrakeSys3Lvl3",
        opt1: {
          AirBrakeSys3Lvl3: {
            default: {
              airbrake: true,
            },
          },
        },
      },
      {
        code: "AirBrakeSys4Lvl3",
        opt1: {
          AirBrakeSys4Lvl3: {
            default: {
              airbrake: true,
            },
          },
        },
      },
      {
        code: "AirBrakeAFM92Days",
        opt1: {
          AirBrakeAFM92Days: {
            default: {
              airbrake: true,
            },
          },
        },
      },
      {
        code: "ONR_be0a4_HBD",
        opt1: {
          ONR_be0a4_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_be1a5_HBD",
        opt1: {
          ONR_be1a5_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_be2a6_HBD",
        opt1: {
          ONR_be2a6_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_be3a7_HBD",
        opt1: {
          ONR_be3a7_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_be4a8_HBD",
        opt1: {
          ONR_be4a8_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_be5a9_HBD",
        opt1: {
          ONR_be5a9_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_be6a10_HBD",
        opt1: {
          ONR_be6a10_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_be7a11_HBD",
        opt1: {
          ONR_be7a11_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_be0b1_HBD",
        opt1: {
          ONR_be0b1_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_be1b2_HBD",
        opt1: {
          ONR_be1b2_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_be2b3_HBD",
        opt1: {
          ONR_be2b3_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_be3b4_HBD",
        opt1: {
          ONR_be3b4_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_be4b5_HBD",
        opt1: {
          ONR_be4b5_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_bu0a25_HBD",
        opt1: {
          ONR_bu0a25_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_bu1a26_HBD",
        opt1: {
          ONR_bu1a26_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_bu2a27_HBD",
        opt1: {
          ONR_bu2a27_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_bu3a28_HBD",
        opt1: {
          ONR_bu3a28_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_bu4a29_HBD",
        opt1: {
          ONR_bu4a29_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_bu0b17_HBD",
        opt1: {
          ONR_bu0b17_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_bu1b18_HBD",
        opt1: {
          ONR_bu1b18_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_bu3b20_HBD",
        opt1: {
          ONR_bu3b20_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_bu0ssit203_HBD",
        opt1: {
          ONR_bu0ssit203_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_bu0ssit1001e7_HBD",
        opt1: {
          ONR_bu0ssit1001e7_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_bu1ssit901_HBD",
        opt1: {
          ONR_bu1ssit901_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_bu0ssit1101_HBD",
        opt1: {
          ONR_bu0ssit1101_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_bu1ssit1103_HBD",
        opt1: {
          ONR_bu1ssit1103_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_bu2ssit1104_HBD",
        opt1: {
          ONR_bu2ssit1104_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_de0a16_HBD",
        opt1: {
          ONR_de0a16_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_de1a17_HBD",
        opt1: {
          ONR_de1a17_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_de2a18_HBD",
        opt1: {
          ONR_de2a18_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_de3a19_HBD",
        opt1: {
          ONR_de3a19_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_de4a20_HBD",
        opt1: {
          ONR_de4a20_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_de0b9_HBD",
        opt1: {
          ONR_de0b9_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_de1b10_HBD",
        opt1: {
          ONR_de1b10_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_de2b11_HBD",
        opt1: {
          ONR_de2b11_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_de3b12_HBD",
        opt1: {
          ONR_de3b12_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_de4b13_HBD",
        opt1: {
          ONR_de4b13_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_ho0a21_HBD",
        opt1: {
          ONR_ho0a21_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_ho1a22_HBD",
        opt1: {
          ONR_ho1a22_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_ho2a23_HBD",
        opt1: {
          ONR_ho2a23_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_ho3a24_HBD",
        opt1: {
          ONR_ho3a24_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_ho0b14_HBD",
        opt1: {
          ONR_ho0b14_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_ho1b15_HBD",
        opt1: {
          ONR_ho1b15_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_ho2b16_HBD",
        opt1: {
          ONR_ho2b16_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_tr0a1_HBD",
        opt1: {
          ONR_tr0a1_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_tr1a2_HBD",
        opt1: {
          ONR_tr1a2_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_tr2a3_HBD",
        opt1: {
          ONR_tr2a3_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_tr0na_HBD",
        opt1: {
          ONR_tr0na_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_tr1na_HBD",
        opt1: {
          ONR_tr1na_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_tr2na_HBD",
        opt1: {
          ONR_tr2na_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_tr0a12_HBD",
        opt1: {
          ONR_tr0a12_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_tr1a13_HBD",
        opt1: {
          ONR_tr1a13_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_tr2a14_HBD",
        opt1: {
          ONR_tr2a14_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_tr3a15_HBD",
        opt1: {
          ONR_tr3a15_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_tr0b6_HBD",
        opt1: {
          ONR_tr0b6_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_tr1b7_HBD",
        opt1: {
          ONR_tr1b7_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ONR_tr2b8_HBD",
        opt1: {
          ONR_tr2b8_HBD: {
            default: {
              hbdTests: true,
            },
          },
        },
      },
      {
        code: "ETR_WeeklyTests",
        opt1: {
          ETR_WeeklyTests: {
            default: {
              etrWeeklyReport: true,
            },
          },
        },
      },
      {
        code: "ETR_CW_MSGCP3000_4000",
        opt1: {
          ETR_CW_MSGCP3000_4000: {
            default: {
              etrGCPReport: true,
            },
          },
        },
      },
      {
        code: "ETR_CW_MS62590",
        opt1: {
          ETR_CW_MS62590: {
            default: {
              etr62590Report: true,
            },
          },
        },
      },
    ],
    combinedReportsTitle: [
      {
        code: "CPGradeCrossing",
        opt1: {
          title: "Test & Inspection Report",
          testDescription: "Highway Grade Crossing",
        },
      },
      {
        code: "GradeCrossingWarningReport",
        opt1: {
          title: "Highway Grade Crossing Inspection",
          testDescription: "Grade Crossing Warning System Annual Test Report",
        },
      },
      {
        code: "sfrtaSwitchTests",
        opt1: {
          title: "Switch Tests",
          testDescription: "Switch Tests",
        },
      },
      {
        code: "sfrtaSwitchMTests",
        opt1: {
          title: "Switch Monthly Tests",
          testDescription: "Switch Monthly Tests",
        },
      },
      {
        code: "sfrtaSwitchQTests",
        opt1: {
          title: "Switch Quarterly Tests",
          testDescription: "Switch Quarterly Tests",
        },
      },
      {
        code: "sfrtaInterLockingTests",
        opt1: {
          title: "Locking Tests & Inspections",
          testDescription: "Locking Tests & Inspections",
        },
      },
      {
        code: "sfrtaHotBoxDefectDetectorTests",
        opt1: {
          title: "Hot Box Defect Detector Tests",
          testDescription: "Hot Box Defect Detector Tests",
        },
      },
      {
        code: "atlasInspectionConnection",
        opt1: {
          title: "Inspection and Connections",
          testDescription: "Inspection and Connections",
        },
      },
      {
        code: "onrSwitchTests",
        opt1: {
          title: "Switch Tests",
          testDescription: "Switch Tests",
        },
      },
      {
        code: "lirrHighwayGradeCrossing",
        opt1: {
          title: "Test & Inspection Report",
          testDescription: "Highway Grade Crossing",
        },
      },
      {
        code: "lirrSwitchTestsAndInspection",
        opt1: {
          title: "Switch Tests",
          testDescription: "Switch Tests",
        },
      },
      {
        code: "periodic",
        opt1: {
          title: "Periodic Combined Reports",
          testDescription: "Periodic Combined",
        },
      },
      {
        code: "airbrake",
        opt1: {
          title: "AirBrake Combined Reports",
          testDescription: "AirBrake Reports",
        },
      },
      {
        code: "eventRecorder",
        opt1: {
          title: "Event Recorder Reports",
          testDescription: "Event Recorder Reports",
        },
      },
      {
        code: "hbdTests",
        opt1: {
          title: "Hot Box Detector",
          testDescription: "Hot Box Detector",
        },
      },
      {
        code: "etrWeeklyReport",
        opt1: {
          title: "Weekly Crossing Test",
          testDescription: "Weekly Crossing Test",
        },
      },
      {
        code: "etrGCPReport",
        opt1: {
          title: "CW & MS GCP 3000/4000",
          testDescription: "CW & MS GCP 3000/4000",
        },
      },
      {
        code: "etr62590Report",
        opt1: {
          title: "CW & MS 62590",
          testDescription: "CW & MS 62590",
        },
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/components/Reports/sims/CombineMethods/GroupReportLookups.js